import {fromJS, Map} from 'immutable';
import {Store} from 'client/framework';

import {getAssignmentQuestionStatistics} from 'framework/MandarkAPI/Assignments/Assignments';

import stats from 'lib/StatsUtil';

import AssignmentDrilldownStore from '../AssignmentDrilldownStore';

import QuestionsActions from './QuestionsActions';

/*
  TODO:
    Eventually this will get wired up to make a request to an assignment's
    questions_v1 relationship, and have its react component render them on its
    own
*/
export class QuestionsStore extends Store {
  constructor(name) {
    super(name);

    this.initialData = fromJS({
      classroomId: null,
      assignmentId: null
    });

    this.setInitialData(this.initialData);
    this.handle(QuestionsActions.INITIALIZE_QUESTION_LIST, this._initializeQuestionList);
  }

  _initializeQuestionList(initialData) {
    this.writeData((state) => {
      return state
        .set('classroomId', initialData.get('classroomId'))
        .set('assignmentId', initialData.get('assignmentId'));
    });
  }

  _makeQuestionStatsQuery() {
    return {
      classroomId: this.readData('classroomId'),
      assignmentId: this.readData('assignmentId')
    };
  }

  hasQuestionStats() {
    const statsQuery = this._makeQuestionStatsQuery();
    if (!statsQuery.classroomId || !statsQuery.assignmentId) {
      return false;
    }
    return getAssignmentQuestionStatistics(statsQuery).hasReceivedData();
  }

  getQuestionStats() {
    return getAssignmentQuestionStatistics(this._makeQuestionStatsQuery());
  }

  _getQuestionStatsInterface() {
    return this.getQuestionStats().interface;
  }

  getStudentsThatHaveAnsweredCorrectly(questionId) {
    return this._getQuestionStatsInterface().getStudentsThatHaveAnsweredCorrectly(questionId);
  }

  getStudentsThatHaveAnswered(questionId) {
    return this._getQuestionStatsInterface().getStudentsThatHaveAnswered(questionId);
  }

  getStudentsThatHaveAnsweredIncorrectly(questionId) {
    return this._getQuestionStatsInterface().getStudentsThatHaveAnsweredIncorrectly(questionId);
  }

  getAverageTimeElapsed(questionId) {
    const timeElapsedString = this._getQuestionStatsInterface().getAverageTimeElapsed(questionId);
    return parseFloat(timeElapsedString, 10);
  }

  getQuestionSetId(questionId) {
    return this._getQuestionStatsInterface().getQuestionSetId(questionId);
  }

  getQuestionsByQuestionId() {
    return this._getQuestionStatsInterface().all;
  }

  getQuestionTableData() {
    return this.getQuestionsByQuestionId().map((question, questionId) => {
      const studentsThatHaveAnsweredCorrectly =
        this.getStudentsThatHaveAnsweredCorrectly(questionId);
      const studentsThatHaveAnswered = this.getStudentsThatHaveAnswered(questionId);
      const studentsThatHaveAnsweredIncorrectly =
        this.getStudentsThatHaveAnsweredIncorrectly(questionId);
      const totalStudents = AssignmentDrilldownStore.getActiveAssignmentStatsStudents();
      const studentsThatHaveNotAnswered = totalStudents - studentsThatHaveAnswered;
      return new Map({
        studentsThatHaveAnsweredCorrectly,
        studentsThatHaveAnswered,
        studentsThatHaveAnsweredIncorrectly,
        studentsThatHaveNotAnswered,
        totalStudents,
        correctPercentage: stats.percentage(
          studentsThatHaveAnsweredCorrectly,
          studentsThatHaveAnswered
        ),
        incorrectPercentage: stats.percentage(
          studentsThatHaveAnsweredIncorrectly,
          studentsThatHaveAnswered
        ),
        unansweredPercentage: stats.percentage(
          studentsThatHaveNotAnswered,
          studentsThatHaveAnswered
        ),
        isUnanswered: studentsThatHaveAnswered === 0,
        avgDuration: this.getAverageTimeElapsed(questionId),
        // TODO: figure out how to move questionSetSlug out of the drilldown store and into the question store
        questionSetSlug: AssignmentDrilldownStore.getSlugForQuestion(questionId),
        questionSlug: question.get('question_slug_id'),
        questionName: AssignmentDrilldownStore.getActiveAssignmentQuestionTitle(questionId)
      });
    });
  }
}

export default new QuestionsStore('QuestionsStore');
